
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"matrix(2,0,0,2,0,0)"}},[_c('defs',[_c('style',[_v('.a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}')])]),_c('title',[_v('messages-bubble-square-star')]),_c('path',{staticClass:"a",attrs:{"d":"M8.223,19.9,3.75,23.25v-4.5H2.25a1.5,1.5,0,0,1-1.5-1.5v-15A1.5,1.5,0,0,1,2.25.75h19.5a1.5,1.5,0,0,1,1.5,1.5v9"}}),_c('path',{staticClass:"a",attrs:{"d":"M17.948,11.68,19.489,15h3a.735.735,0,0,1,.518,1.283l-2.6,2.562,1.442,3.314a.786.786,0,0,1-1.119.982l-3.486-1.961-3.487,1.961a.786.786,0,0,1-1.119-.982l1.443-3.314-2.6-2.562A.734.734,0,0,1,11.989,15h3l1.544-3.323A.8.8,0,0,1,17.948,11.68Z"}})])])
          )
        }
      }
    